import { Button } from "@fluentui/react-northstar";

import { PollyIcon } from "../../../../_shared/components/PollyIcon";

type props = {
  setCollapsed?: (collapsed: boolean) => void;
};
export const AuthoringQuestionCollapseButton: React.FC<props> = ({ setCollapsed }) => {
  return (
    <Button
      content={"Save"}
      icon={<PollyIcon icon="correct-icon" inheritColor />}
      size="medium"
      onClick={() => {
        if (setCollapsed) {
          setCollapsed(true);
        }
      }}
    />
  );
};
